function getPieChartOptions(
  finalData,
  locationName
) {

  return {
    
    title:{text:''},
    legend: {
      layout: 'vertical',
      align: 'right',
      verticalAlign: 'middle',
      itemMarginTop: 10,
      itemMarginBottom: 10,
      itemStyle: {
        width: '100%' // or whatever
    },
      labelFormatter: function () {
        let url='<span style="font-size:14px;font-weight:400;font-family:Optum Sans;color:#4B4D4F;">'+ 
        this.name+'  </span> <span style="font-size:14px;font-weight:400;font-family:Optum Sans;margin-right:10px;">  '+ this.y+'</span>';
      return    (
      url
      )          
    }
    },
    tooltip: {
      enabled: true, //Added to disable tooltip
      borderRadius: 10,
      backgroundColor: null,
      borderWidth: 0,
      shadow: false,
      useHTML: true,
      style: {
        padding: 0,
      },
      
      formatter: function () {
        return (
          `<div style="background-color: #FFFFFF;color:4B4D4F;padding: 12px 12px;border: 1px  solid #CBCCCD;
          border-radius: 4px; font-family: 'Optum Sans', sans-serif;
          font-style: normal;
          font-weight: 700;
          font-size: 14px;
          ">
          <div >${this.key} </div>
          <div style="color:#002677;padding-top:10px">${locationName}</div>
          <div style="padding-top:10px">${this.y}</div>
          </div>`
        )
      },
    },
    credits:{enabled:false},
    subtitle: {
      useHTML: true,
      text: `<div style='text-align:center;width:100px;font-family:Optum Sans;'><span style="font-size:24px;font-weight:700;color:#002677">${finalData[0].data}</span><br><span style="font-size: 16px;color:#002677;"> NDC Counts</span></div>`,
      floating: true,
      verticalAlign: 'middle',
      y: 0,
      x:-85
  },
  
     series: [{
      

         showInLegend: true,
         dataLabels: {enabled: false},
         type: 'pie',
         size: '90%',
         innerSize: '70%',
         colorByPoint: true,
         data: finalData[1].data,
         
     }],
    
    
  }
}

export default getPieChartOptions
